import {
  makeAutoObservable,
  observable,
  action,
  computed,
  runInAction,
  toJS,
  autorun,
  onBecomeUnobserved,
  reaction,
} from "mobx";
import { commonAxios } from "../../pages/ExperianPage/CommonAxios";

class PaymentStatusStore {
  config = {
    success: {
      title: "Payment Successful",
      slogan: "Thank You! Your Transaction Was a Success",
      buttonName: "Back Home",
      redirectLink:"/dashboard"
    },
    unSuccess: {
      title: "Payment Failed",
      slogan: "Something Went Wrong. Please Retry Your Payment",
      buttonName: "Try Again",
      redirectLink:"/subscription-page"
    },
  };

  constructor(rootstore) {
    this.rootstore = rootstore;
    makeAutoObservable(this);
  }
  handleButtonClick = (link) => {
    window.location.href = link
  }
}
export default PaymentStatusStore;
